import { connect } from "react-redux";
import { compose } from "redux";
import { WithAppendHeaderAndFooterHOC } from "../../HOC/WithAppendHeaderAndFooterHOC";
import { WithAppendSidebarHOC } from "../../HOC/WithAppendSidebarHOC";
import ContractSample from "./ContractSample";
import { getBaseUrlSelector } from "../../globalState/app/selectros";


let mapStateToProps = (state) => {
  return {
    baseUrl: getBaseUrlSelector(state),
  }
};

export default compose(connect(mapStateToProps, {}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC)(ContractSample);



